<script lang="ts" setup>
import type {TableDTO} from '@/ts/types/dto/interventions-dto';
import TableComponent from '@/vue/molecules/components/table-component.vue';
import ReadOnlyNonCollapsable from '@/vue/molecules/read-only/helpers/read-only-non-collapsable.vue';
import {ComponentTheme} from '@/ts/types/component/layout-component-types';

defineProps<{
  table: TableDTO;
}>();
</script>

<template>
  <read-only-non-collapsable :active="false" default-opened>
    <table-component
      :table="table"
      class="table"
      :theme="ComponentTheme.RAW"
    />
  </read-only-non-collapsable>
</template>
<style lang="scss" scoped>
.table {
  margin: calc(-1*var(--Spacing-spacing-3)) 0 ;
}
</style>
